import { CalendarDisplayData } from './calendarStore.types';

type CalendarMapping = Record<string, string[]>;

export const recalculateMappings = (calendars: {
  [calendarId: string]: CalendarDisplayData;
}): {
  entityIdsPerCalendarId: CalendarMapping;
  calendarIdsPerEntityId: CalendarMapping;
} => {
  const entityIdsPerCalendarId = Object.entries(calendars).reduce(
    (acc, [calendarId, calendar]) => {
      acc[calendarId] = calendar.sources.map(
        (x) => x.planningEntityIdentifier.entityId!
      );
      return acc;
    },
    {} as Record<string, string[]>
  );

  const uniqueEntityIds = new Set<string>();
  Object.values(calendars)
    .flatMap((calendar) => calendar.sources)
    .map((src) => src.planningEntityIdentifier.entityId!)
    .forEach((entityId) => {
      if (!uniqueEntityIds.has(entityId)) uniqueEntityIds.add(entityId);
    });

  const calendarIdsPerEntityId = [...uniqueEntityIds].reduce(
    (acc, entityId) => {
      acc[entityId] = Object.entries(calendars)
        .filter(([_, cal]) =>
          cal.sources.some(
            (src) => src.planningEntityIdentifier.entityId == entityId
          )
        )
        .map(([calendarId]) => calendarId);
      return acc;
    },
    {} as Record<string, string[]>
  );

  return {
    entityIdsPerCalendarId,
    calendarIdsPerEntityId
  };
};

export const getNewCalendarId = (calendarIds: string[]): string => {
  const newId = (
    Math.max(0, ...calendarIds.map((id) => Number(id) || 0)) + 1
  ).toString();

  return newId;
};
